module.exports = __webpack_public_path__ + "img/dashboard.8fa050d4.png";